import { Box, Text } from "@chakra-ui/layout";
import { ReadingValueBreakdown } from "@tether-web-portal/components/areas/location-reading/makeSampleBreakdown";
import { getCovidRiskLevel, getCovidRiskLevelColor } from "@tether-web-portal/utils/covid-care";

interface DeviceReadingItemProps extends ReadingValueBreakdown {
  mr?: number;
  showCovidRiskLevel: boolean;
}

export const DeviceReadingItem = ({
  value,
  IconComponent,
  label,
  subTitle,
  isHealthy,
  ignoreHealthReading,
  showCovidRiskLevel,
  mr = 4,
}: DeviceReadingItemProps) => {
  const showRisk = !ignoreHealthReading && isHealthy === false;
  const riskLevel = showCovidRiskLevel ? getCovidRiskLevel(value) : undefined;
  return (
    <Box display="flex" flexDirection="row" alignItems="center" mr={mr} gap={1}>
      <Box
        borderRadius="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg={showRisk ? "red.50" : "gray.50"}
        w="28px"
        h="28px"
      >
        <IconComponent size={16} color={showRisk ? "#FB5169" : undefined} />
      </Box>
      <Text color={showRisk ? "red.600" : "gray.500"}>{label}</Text>
      {subTitle && (
        <Text fontSize={12} color={"gray.500"} mt={"auto"}>
          {subTitle}
        </Text>
      )}
      {showCovidRiskLevel && riskLevel && (
        <Text ml={"4px"} fontWeight={600} fontSize={12} color={getCovidRiskLevelColor(riskLevel)}>
          {`${riskLevel.toString()[0]}${riskLevel.substr(1).toLowerCase()} Risk`}
        </Text>
      )}
    </Box>
  );
};
